import { Reducer } from "redux";

import { ApplicationStatefulModule } from "@multiweb/types/react";
import { NAME } from "./constants";
import { reducer } from "./reducer";
import { saga } from "./saga";
import { FramesMapState } from "./types";

export {
    createInitFrameAction,
    createInitFrameWithDataSourceAction,
    createSetActionAreaAction,
    createSetAllowMultiselectAction,
    createSetCanValueLoadAction,
    createSetEmptyMessageCustomizationAction,
    createSetInteractiveAction,
    createSetLoadOnScrollAction,
    createSetMultiselectModeAction,
    createSetRowTemplateAction,
    createSetSelectedRecordsAction,
    createSetShowHeaderAction,
    createSetVisibilityAction,
    createTrySelectRecordAction,
} from "./actions";
export { GridLayoutMultiwebItem, LiteListFrame } from "./components";
export * from "./components/EmptyMessage";
export {
    HANDLE_RECORD_CLICK,
    LLF_EMPTY_VALUE,
    PARTICIPANT_TYPE_ATTRIBUTE_RENDERER,
    ROLE_USERS_ATTRIBUTE_RENDERER,
    SET_ALLOW_MULTISELECT,
    SET_MULTISELECT_MODE,
    SET_SELECTED_RECORDS,
    TRY_SELECT_RECORD,
} from "./constants";
export { WFParticipantsDialog } from "./GridParticipants";
export * from "./locKeys";
export {
    handleRecordClickSaga,
    setAllowMultiSelectSaga,
    setMultiselectSaga,
    setSelectedRecordsSaga,
    trySelectRecordSaga,
} from "./saga";
export {
    createGetEmptyMessageSelector,
    createGetRowRerenderKey,
    getActionArea,
    getAllowMultiselectMode,
    getCanValueLoad,
    getEmptyMessageCustomization,
    getInteractive,
    getLoadOnScroll,
    getNoItemsFilterIcon,
    getNoItemsFilterText,
    getNoItemsFulltextSearchIcon,
    getNoItemsFulltextSearchText,
    getNoItemsIcon,
    getNoItemsText,
    getRowTemplate,
    getShowHeader,
    getVisibility,
} from "./selectors";
export {
    ActionArea,
    DefaultRowTemplate,
    EmptyMessageCustomization,
    EmptyMessageSettings,
    IHandleRecordClickAction,
    InitFrameConfig,
    ISetActionAreaAction,
    ISetAllowMultiselectAction,
    ISetCanValueLoadAction,
    ISetEmptyMessageCustomizationAction,
    ISetInteractiveAction,
    ISetLoadOnScrollAction,
    ISetMultiselectModeAction,
    ISetRowTemplateAction,
    ISetShowHeaderAction,
    ParticipantsAttributes,
    RowTemplateType,
} from "./types";

export const framesModule: ApplicationStatefulModule<typeof NAME, Reducer<FramesMapState>> = {
    NAME,
    saga,
    reducer,
};
